<script>
    export default {
        props: {
            url: {
                type: String,
                default: '/'
            },
            method: {
                type: String,
                default: 'post'
            }
        },
        data() {
            return {
                processing: false
            }
        },
        methods: {
            getMethodParams(data) {
                if (this.method === 'post') {
                    return {};
                }
                return data ? data : this.requestData();
            },
            postMethodData(data) {
                if (this.method === 'get') {
                    return {};
                }
                return data ? data : this.requestData();
            },
            requestData() {
                return {};
            },
            startProcessing() {
                this.processing = true;
                this.startProcessingEvent();
            },
            stopProcessing() {
                this.processing = false;
                this.stopProcessingEvent();
            },
            startProcessingEvent() {},
            stopProcessingEvent() {},
            makeCall(success, failure, data) {
                this.startProcessing();
                this.makeRequest(success, failure, data);
            },
            makeRequest(success, failure, data, url, method) {
                axios.request({
                        url: url || this.url,
                        method: method || this.method,
                        params: this.getMethodParams(data),
                        data: this.postMethodData(data)
                    })
                    .then(success)
                    .catch(failure);
            }
        }
    }
</script>